// src/pages/clients/grm/reports/R0006/configs/tables.config.js

export const grmTableConfig = {
  salesPerformance: {
    title: "Sales Performance - GRM Division",
    columns: [
      { 
        key: 'restaurant', 
        label: 'Restaurant', 
        width: '200px',
        sortable: true 
      },
      { 
        key: 'projection', 
        label: 'Projection', 
        type: 'currency',
        width: '120px',
        sortable: true 
      },
      { 
        key: 'actual', 
        label: 'Actual', 
        type: 'currency',
        width: '120px',
        sortable: true 
      },
      { 
        key: 'variance', 
        label: 'Variance', 
        type: 'variance',
        width: '120px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'checkCount', 
        label: 'Check Count', 
        type: 'number',
        width: '100px',
        sortable: true 
      },
      { 
        key: 'avgCheck', 
        label: 'Avg Check', 
        type: 'currency',
        width: '100px',
        sortable: true 
      },
      { 
        key: 'opportunity', 
        label: 'Opportunity', 
        type: 'currency',
        width: '120px',
        sortable: true,
        colorCoded: true 
      }
    ],
    
    // GRM-specific styling
    styling: {
      headerColor: '#29261f',
      accentColor: '#cf9e0b',
      positiveColor: '#4caf50',
      negativeColor: '#f44336'
    },
    
    // Features enabled for GRM
    features: {
      export: true,
      sorting: true,
      filtering: true,
      grouping: false,
      pagination: false  // GRM prefers all data visible
    }
  },
  
  laborHours: {
    title: "Labor Hours Management - GRM Division",
    columns: [
      { 
        key: 'restaurant', 
        label: 'Restaurant', 
        width: '200px',
        sortable: true 
      },
      { 
        key: 'fohSchedVsModel', 
        label: 'FOH: Sched vs Model', 
        type: 'variance',
        width: '140px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'fohChangeDuringDay', 
        label: 'FOH: Change During Day', 
        type: 'variance',
        width: '160px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'fohVarianceToAdjusted', 
        label: 'FOH: Variance to Adjusted', 
        type: 'variance',
        width: '170px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'bohSchedVsModel', 
        label: 'BOH: Sched vs Model', 
        type: 'variance',
        width: '140px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'bohChangeDuringDay', 
        label: 'BOH: Change During Day', 
        type: 'variance',
        width: '160px',
        sortable: true,
        colorCoded: true 
      },
      { 
        key: 'bohVarianceToAdjusted', 
        label: 'BOH: Variance to Adjusted', 
        type: 'variance',
        width: '170px',
        sortable: true,
        colorCoded: true 
      }
    ],
    
    styling: {
      headerColor: '#29261f',
      accentColor: '#cf9e0b',
      positiveColor: '#4caf50',
      negativeColor: '#f44336'
    },
    
    features: {
      export: true,
      sorting: true,
      filtering: false,
      grouping: false,
      pagination: false
    }
  }
};